import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Send, ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Messages() {
  const { taskId } = useParams();
  const { user } = useAuth();
  const [messages, setMessages] = useState([]);
  const [content, setContent] = useState("");
  const [task, setTask] = useState(null);
  const endRef = useRef(null);

  const load = async () => {
    const [m, t] = await Promise.all([
      api.get(`/messages/${taskId}`),
      api.get(`/tasks/${taskId}`),
    ]);
    setMessages(m.data);
    setTask(t.data);
  };

  useEffect(() => {
    load();
    const i = setInterval(load, 5000);
    return () => clearInterval(i);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const send = async () => {
    if (!content.trim()) return;
    await api.post(`/messages/${taskId}`, { content });
    setContent("");
    load();
  };

  return (
    <div className="max-w-2xl mx-auto h-[calc(100vh-140px)] flex flex-col">
      <div className="card-surface p-4 flex items-center gap-3">
        <Link to={`/tasks/${taskId}`} className="text-navy" data-testid="back-to-task"><ArrowLeft /></Link>
        <div>
          <div className="font-heading font-black text-navy">{task?.title || "Conversation"}</div>
          <div className="text-xs text-[#475569]">Messagerie Go Helper</div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto py-4 space-y-2">
        <div className="mx-auto bg-amber-50 border border-amber-200 text-amber-900 text-xs rounded-xl px-4 py-2 font-semibold max-w-md text-center" data-testid="bypass-warning">
          ⚠️ Pour ta sécurité, les numéros de téléphone et adresses email sont automatiquement masqués. Tous les paiements doivent passer par Go Helper.
        </div>
        {messages.length === 0 && (
          <div className="text-center text-[#475569] py-10">Aucun message. Dis bonjour 👋</div>
        )}
        {messages.map((m) => {
          const mine = m.sender_id === user.id;
          return (
            <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid={`msg-${m.id}`}>
              <div className={`max-w-[75%] rounded-2xl px-4 py-2 ${mine ? "bg-navy text-white" : "bg-surface text-navy"}`}>
                <div className="text-xs opacity-70 font-bold mb-0.5">{m.sender_name}</div>
                <div className="whitespace-pre-wrap">{m.content}</div>
                {m.masked && <div className="text-[10px] opacity-70 mt-1 italic">ℹ️ Info personnelle masquée</div>}
              </div>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>

      <div className="flex items-center gap-2 pt-2 border-t border-[#E2E8F0]">
        <input className="input-base" placeholder="Écris un message…" value={content} onChange={(e) => setContent(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && send()} data-testid="msg-input" />
        <button onClick={send} className="btn-primary py-3 px-4" data-testid="msg-send"><Send size={18} /></button>
      </div>
    </div>
  );
}
